import { APIError } from '../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../useAPIProvider';

interface CreateContactArgs {
  telephoneNumber: string;
  workEmail: string;
  personalEmail?: string;
}

export const useCreateContactDetail = () => {
  return useAPIMutation(client => {
    return async ({ ...args }: CreateContactArgs) => {
      const response = await client.contact.postContact({
        body: { ...args }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);
      return response.body;
    };
  });
};

export const useContactDetail = (id?: string) => {
  return useAPIQuery(['getContact', id], async client => {
    if (!id) return null;
    const response = await client.contact.getContact({ params: { id } });
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body;
  });
};

export const useDeleteContact = () => {
  return useAPIMutation(client => async ({ id }: { id: string }) => {
    return await client.contact.deleteContact({ params: { id } });
  });
};

interface UpdateContactArgs extends CreateContactArgs {
  id: string;
}

export const useUpdateContact = () => {
  return useAPIMutation((client, query) => {
    return async ({ id, ...args }: UpdateContactArgs) => {
      const response = await client.contact.updateContact({
        body: { ...args },
        params: {
          id
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);
      await query.invalidateQueries(['getContact', id]);

      return response.body;
    };
  });
};
